export default "__VITE_ASSET__T$9K_uAQ__"